export default "__VITE_ASSET__O2drdx8D__"